import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { canManageProjectSelector } from "~/store/selectors/selector.users";

export const RequireCanManageProject = ({ children, redirectTo }) => {
  const { projectId } = useParams();
  const canManageProject = useSelector((state) => canManageProjectSelector(state, projectId));

  return canManageProject ? children : <Navigate to={redirectTo} />;
};

RequireCanManageProject.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequireCanManageProject.defaultProps = {
  redirectTo: "/not-found",
};
